import { render, staticRenderFns } from "./StandardIconBloc.vue?vue&type=template&id=05f0d316&scoped=true"
import script from "./StandardIconBloc.vue?vue&type=script&lang=js"
export * from "./StandardIconBloc.vue?vue&type=script&lang=js"
import style0 from "./StandardIconBloc.vue?vue&type=style&index=0&id=05f0d316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0d316",
  null
  
)

export default component.exports